/* eslint-disable indent */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len
import React from "react";
import { ReactComponent as AcctIcon } from "../assests/images/sidebar/creditIcon.svg";
import { ReactComponent as AcctIconFilled } from "../assests/images/sidebar/creditFilledIcon.svg";
import { ReactComponent as CashIcon } from "../assests/images/SVG/cashBooking.svg";
import { ReactComponent as DrcIcon } from "../assests/images/sidebar/drsIcon.svg";
import { ReactComponent as DrcFilledIcon } from "../assests/images/sidebar/drsIconFilled.svg";
import { ReactComponent as DAIcon } from "../assests/images/sidebar/daIcon.svg";
import { ReactComponent as PRSFilledIcon } from "../assests/images/sidebar/prsIconFilled.svg";
import { ReactComponent as PRSIcon } from "../assests/images/sidebar/prsIcon.svg";
import { ReactComponent as DAFilledIcon } from "../assests/images/sidebar/daIconFilled.svg";
import { ReactComponent as HomeIcon } from "../assests/images/sidebar/homeIcon.svg";
import { ReactComponent as HomeIconFilled } from "../assests/images/sidebar/homeFilledIcon.svg";

import { ReactComponent as ViewIcon } from "../assests/images/sidebar/viewBooking.svg";
import { ReactComponent as ViewIconFilled } from "../assests/images/sidebar/viewBookingFilled.svg";

import { ReactComponent as MasterListing } from "../assests/images/sidebar/masterdicon.svg";
import { ReactComponent as MasterListingFilled } from "../assests/images/sidebar/mastersfilledicon.svg";

import { ReactComponent as SidebarSetting } from "../assests/images/sidebar/settingsIcon.svg";
import { ReactComponent as SidebarSettingFilled } from "../assests/images/sidebar/settingsfilledicon.svg";

import { ReactComponent as BookingIcon } from "../assests/images/sidebar/bookingIcon.svg";
import { ReactComponent as BookingIconFilled } from "../assests/images/sidebar/bookingFilledIcon.svg";

import { ReactComponent as SettingsIcon } from "../assests/images/sidebar/settingsIcon.svg";
import { ReactComponent as SettingsFilledIcon } from "../assests/images/sidebar/settingsfilledicon.svg";

import { ReactComponent as MasterIcon } from "../assests/images/sidebar/masterdicon.svg";
import { ReactComponent as MasterFilledIcon } from "../assests/images/sidebar/mastersfilledicon.svg";

import { ReactComponent as OnboardSettings } from "../assests/images/sidebar/onboardSettings.svg";
import { ReactComponent as OnboardSettingsFilled } from "../assests/images/sidebar/onboardSettingsFilled.svg";
import { ReactComponent as MessageIcon } from "../assests/images/sidebar/messageIcon.svg";
import { ReactComponent as MessageIconFilled } from "../assests/images/sidebar/messageIconFilled.svg";

import { ReactComponent as DrsIcon } from "../assests/images/sidebar/drsIcon.svg";
import { ReactComponent as DrsFilledIcon } from "../assests/images/sidebar/drsIconFilled.svg";

import { ReactComponent as CashIconFilled } from "../assests/images/SVG/cash-booking-filled.svg";
import { ReactComponent as HubSettingOpen } from "../assests/images/HubAdmineLogo/setting-open.svg";
import { ReactComponent as HubSettingClose } from "../assests/images/HubAdmineLogo/setting-close.svg";
import { ReactComponent as SorterIcon } from "../assests/images/middleMile/sorter-icon.svg";

import { ReactComponent as Search } from "../assests/images/sidebar/searchseriesicon.svg";
import { ReactComponent as SearchFill } from "../assests/images/sidebar/searchseriesflledicon.svg";

import { ReactComponent as PendencyIcon } from "../assests/images/sidebar/pendencyIcon.svg";
import { ReactComponent as PendencyFilledIcon } from "../assests/images/sidebar/pendencyFilledIcon.svg";

import { ReactComponent as InvoiceFilledIcon } from "../assests/images/sidebar/Invoice.svg";
import { ReactComponent as InvoiceIcon } from "../assests/images/sidebar/InvoiceFilled.svg";
import { HomeOutlined } from "@ant-design/icons";
import CODIcon, { CODIconFilled } from "../components/CODIcon";

import constants from "../constants/constants";

const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  CP_OPERATOR,
  CP_BOOKINGONLY,
  ROLE_HOMARKETING,
  CLIENT_ADMIN,
  DP_OPERATOR,
  CENTRALOPS_ADMIN,
  CENTRALOPERATOR,
  MIS_EXECUTIVE,
  ROLE_COSNO,
} = ROLES;

const currentEnv = process.env.REACT_APP_ENV;

const dashboardRoutes = () => {
  return [
    {
      active: "1",
      icon: HomeIcon,
      fillIcon: HomeIconFilled,
      title: "Home",
      id: "home",
      route: "/dashboard",
      role: "",
      showSidebarIcon: true,
    },
    {
      active: "10",
      icon: SidebarSetting,
      fillIcon: SidebarSettingFilled,
      title: "Ecomm Onboarding",
      id: "ecomm-onboarding",
      route: "/ecomm-onboarding",
      role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
      showSidebarIcon: true,
    },
    {
      active: "11",
      icon: SidebarSetting,
      fillIcon: SidebarSettingFilled,
      title: "Cargo Onboarding",
      id: "cargo-onboarding",
      route: "/cargo-onboarding",
      role: [CENTRALOPS_ADMIN],
      showSidebarIcon: true,
    },
    {
      active: "12",
      icon: SidebarSetting,
      fillIcon: SidebarSettingFilled,
      title: "Pincode Management",
      id: "pincode-management",
      route: "/pincode-management",
      role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, CENTRALOPS_ADMIN, MIS_EXECUTIVE],
      showSidebarIcon: true,
    },
  ];
};

const deliveryRoutes = () => {
  return [
    {
      active: "7",
      icon: DrcIcon,
      fillIcon: DrcFilledIcon,
      title: "DRS",
      id: "drs-scanning",
      route: "/drs",
      role: [CP_ADMIN, DP_OPERATOR],
      showSidebarIcon: true,
    },
    {
      active: "9",
      icon: PRSIcon,
      fillIcon: PRSFilledIcon,
      title: "PRS",
      id: "prs",
      route: "/prs",
      role: [CP_ADMIN, DP_OPERATOR, HO_ADMIN],
      showSidebarIcon: true,
    },
    {
      active: "10",
      icon: DAIcon,
      fillIcon: DAFilledIcon,
      title: "DA Management",
      id: "da",
      route: "/da-management",
      role: [CP_ADMIN, ROLE_COSNO],
      showSidebarIcon: true,
    },
    {
      active: "11",
      icon: DAIcon,
      fillIcon: DAFilledIcon,
      title: "Area Management",
      id: "area-management",
      route: "/area-management",
      role: [CP_ADMIN, ROLE_COSNO],
      showSidebarIcon: true,
    },
  ];
};

const codCenterRoutes = () => {
  // Determine COD Center URL based on environment

  let codCenterUrl = `https://${currentEnv === "prod" ? "" : currentEnv
    }codcenter.innofulfill.com/#/auth/login`;

  return [
    {
      active: "1",
      icon: <CODIcon />,
      fillIcon: <CODIconFilled />,
      title: "COD Center Login",
      id: "cod-center-login",
      route: codCenterUrl,
      role: [DP_OPERATOR],
      showSidebarIcon: false,
    },
  ];
};

const ticketSupportRoutes = () => {
  let ticketSupportUrl =
    currentEnv === "prod"
      ? "https://support.innofulfill.com/"
      : "https://qasupport.innofulfill.com/";

  return [
    {
      active: "1",
      icon: MessageIcon,
      fillIcon: MessageIconFilled,
      title: "Ticket Support",
      id: "ticket-support",
      route: ticketSupportUrl,
      role: "",
      showSidebarIcon: true,
    },
  ];
};

const mapMenuItems = (arr) => {
  return arr.map((item) => ({
    key: item.id.replace(/-/g, "").toLowerCase(), // Convert 'account-booking' to 'credit-booking'
    label: item.title,
    route: item.route,
    role: item.role,
  }));
};

const menuItems = [
  {
    active: "1",
    key: "home",
    label: "Home",
    icon: <HomeIconFilled />,
    fillIcon: <HomeIcon />,
    role: [
      CP_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      HO_ADMIN,
      ROLE_HOMARKETING,
      CLIENT_ADMIN,
      DP_OPERATOR,
      CENTRALOPS_ADMIN,
      CENTRALOPERATOR,
      MIS_EXECUTIVE,
    ],
    children: [...mapMenuItems(dashboardRoutes())],
  },
  {
    active: "delivery",
    key: "delivery",
    label: "Delivery",
    icon: <PRSFilledIcon />,
    fillIcon: <PRSIcon />,
    children: [...mapMenuItems(deliveryRoutes())],
    role: [CP_ADMIN, DP_OPERATOR, HO_ADMIN],
  },
  {
    active: "codcenter",
    key: "codcenter",
    label: "COD Center",
    icon: <CODIconFilled />,
    fillIcon: <CODIcon />,
    children: [...mapMenuItems(codCenterRoutes())],
    role: [DP_OPERATOR],
  },
  {
    active: "pendencyoverview",
    key: "pendencyoverview",
    label: "Pendency Overview",
    icon: <PendencyFilledIcon />,
    fillIcon: <PendencyIcon />,
    route: "/cp-pendancy-report",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE, CP_ADMIN, CP_OPERATOR],
  },
  {
    active: "deliveryinvoice",
    key: "deliveryinvoice",
    label: "Delivery Invoice",
    icon: <InvoiceFilledIcon />,
    fillIcon: <InvoiceIcon />,
    role: [HO_ADMIN, CP_ADMIN, CP_OPERATOR],
    children: [
      {
        key: "deliveryinvoicelist",
        label: "Invoice List",
        route: "/delivery-invoice-list",
        role: [HO_ADMIN, CP_ADMIN, CP_OPERATOR],
      },
      {
        key: "deliveryinvoicereport",
        label: "Invoice Report",
        route: "/delivery-invoice-report",
        role: [HO_ADMIN, CP_ADMIN, CP_OPERATOR],
      },
    ],
  },
  {
    active: "ticketsupport",
    key: "ticketsupport",
    label: "Ticket Support",
    icon: <MessageIconFilled />,
    fillIcon: <MessageIcon />,
    children: [...mapMenuItems(ticketSupportRoutes())],
    role: "",
  },
];

export { menuItems };
